import unitedStates from '@occc-app/lib/constants/unitedStates';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { ItemsOrViewAll } from '../../../components';

export const StateConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const cst = getConstraintsByType('ConstraintLocationInState', constraints);
  const stateIds = [...new Set(cst.flatMap((c) => c.states))];
  const stateItems = stateIds.length
    ? unitedStates
        .filter((us) => stateIds.includes(us.id))
        .map((item) => ({
          id: item.id,
          label: item.text ?? item.id,
        }))
    : [];

  return <ItemsOrViewAll label='State Restrictions' itemName='State' items={stateItems} />;
};
